'use es6';

import { Record } from 'immutable';
import HighLowRecord from './HighLowRecord';
export default Record({
  desktop: HighLowRecord,
  mobile: HighLowRecord
});